/**
 * @Author: DKing
 * @Desc: 过滤器合集
 * @Date: 2019-07-15
 */

import { MessageBox } from "element-ui";

/**
 * Desc:不识别标签转换
 * @param {String} str 需要被转换的字符
 * */
export const transformDom = str => {
  var strTem = "";
  if (str.length === 0) return;
  strTem = str.replace(/&/g, "&gt;");
  strTem = strTem.replace(/</g, "&lt;");
  strTem = strTem.replace(/>/g, "&gt;");
  strTem = strTem.replace(/ /g, "&nbsp;");
  strTem = strTem.replace(/\'/g, "&#39;");
  strTem = strTem.replace(/\"/g, "&quot;");
  strTem = strTem.replace(/\n/g, "");

  return strTem;
};

/**
 * Desc: 去除字符串中的字母
 * @param {String} str 需要被转换的字符
 * */
export const transformLetter = str => {
  if (checkNull(str)) {
    return;
  }

  var reg = /[a-zA-Z]/g;
  var result = str.replace(reg, "");
  return result;
};

/**
 * Desc: 去除字符串中的数字
 * @param {String} str 需要被转换的字符
 * */
export const checkIsNumber = str => {
  if (checkNull(str)) {
    return;
  }

  var reg = /[0-9]+/g;
  var result = str.replace(reg, "");
  return result;
};

/**
 * Form
 * 数字校验
 * @param {number} number*/
export const formatNumber = number => {
  if (checkNull(number)) {
    return false;
  }

  var partten = /^\d/;
  return partten.test(number);
};

/**
 * Price
 * 精度 分转元
 * @param {Number,String} fen 需要被转换的分
 */
export const fenToYuan = fen => {
  // 如分转元，保留小数点后两位，则如实参含有小数点（四位小数），则截取掉 - DK
  // console.log(fen)
  if (!checkNull(fen)) {
    let fenTemp = fen.toString();
    let dotIndex = fenTemp.indexOf(".");
    if (dotIndex > 0) {
      fenTemp = fenTemp.substr(0, dotIndex);
    }

    var num = (fenTemp / 100).toString();
    // console.log('fenTemp:',fenTemp)
    var reg =
      num.indexOf(".") > -1
        ? /(\d{1,3})(?=(?:\d{3})+\.)/g
        : /(\d{1,3})(?=(?:\d{3})+$)/g;
    num = toDecimal2(num.replace(reg, "$1"));
    return num;
  }
};

/**
 * Price
 * 转换金额拼接单位
 * 分 - 万/亿
 * @param  {Number} num [分]
 * */
export const fenToWanNoFixed = num => {
  let numYuan = Math.round(Number(num) / 100);
  const vLength = String(numYuan).length;
  if (vLength <= 8) {
    numYuan /= Math.pow(10, 4);
    numYuan = numYuan == 0 ? "0" : Math.round(numYuan) + "万";
  } else {
    numYuan /= Math.pow(10, 8);
    numYuan = Math.round(numYuan) > 10 ? 10 : numYuan;
    numYuan = Math.round(numYuan) + "亿";
  }
  return numYuan;
};

/**
 * Price
 * 精度 分转元
 * @param {Number,String} fen 需要被转换的分
 * 如分转元，保留小数点后两位，则如实参含有小数点,则四舍五入
 */

export const fenToYuanRound = fen => {
  if (checkNull(fen)) {
    return;
  }
  let fenTemp = fen.toString();
  var num = (fenTemp / 100).toString();

  var reg =
    num.indexOf(".") > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g;
  var number = Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2);

  num = toDecimal2(number.toString().replace(reg, "$1"));

  return num;
};

/**
 * Price
 * 保留小数点后四位
 * @param {Number,String} fen 需要被转换的钱
 * */
export const fenToYuanToDecimal4 = fen => {
  var num = fen;
  num = fen / 100;
  num += "";
  var reg =
    num.indexOf(".") > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g;

  var number = num;
  number = Math.round(number * Math.pow(10, 4)) / Math.pow(10, 4); //四舍五入
  number = Number(number).toFixed(4); //补足位数
  // console.log(number)
  return number;
};

/**
 * Price
 * 判断小数点后的位数
 * @param {String} num [要判断的数]
 * true 通过 false 未通过
 * */
export const checkDotBehindNum = (num, dotNum) => {
  // console.log(dotNum);
  let arr = num.toString().split(".");
  if (arr.length > 1) {
    return arr[1].length <= dotNum;
  } else {
    return true;
  }
};

/**
 * Price
 * 精度 元转分

 * */
export const yuanToFen = yuan => {
  if (yuan == "") return "";
  var m = 0,
    s1 = yuan.toString(),
    s2 = "100";
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};

/**
 * 金额小写转大写
 * @param {money} money [要转换的钱]
 * */
export const priceUppercase = money => {
  var cnNums = new Array(
    "零",
    "壹",
    "贰",
    "叁",
    "肆",
    "伍",
    "陆",
    "柒",
    "捌",
    "玖"
  ); //汉字的数字
  var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
  var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
  var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
  //var cnInteger = "整"; //整数金额时后面跟的字符
  var cnIntLast = "元"; //整型完以后的单位
  var maxNum = 999999999999999.9999; //最大处理的数字

  var IntegerNum; //金额整数部分
  var DecimalNum; //金额小数部分
  var ChineseStr = ""; //输出的中文金额字符串
  var parts; //分离金额后用的数组，预定义
  if (money == "") {
    return "";
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    // $.alert('超出最大处理数字');
    return "";
  }
  if (money == 0) {
    ChineseStr = cnNums[0] + cnIntLast;
    return ChineseStr;
  }
  money = money.toString(); //转换为字符串
  if (money.indexOf(".") == -1) {
    IntegerNum = money;
    DecimalNum = "";
    cnIntLast = "元整";
  } else {
    parts = money.split(".");
    IntegerNum = parts[0];
    DecimalNum = parts[1].substr(0, 4);
  }
  let zeroCount = 0;
  let IntLen = 0;
  let n;
  let p;
  let m;
  let q;
  let decLen = 0;
  if (parseInt(IntegerNum, 10) > 0) {
    //获取整型部分转换
    zeroCount = 0;
    IntLen = IntegerNum.length;
    for (var i = 0; i < IntLen; i++) {
      n = IntegerNum.substr(i, 1);
      p = IntLen - i - 1;
      q = p / 4;
      m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0];
        }
        zeroCount = 0; //归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q];
      }
    }
    ChineseStr += cnIntLast;
    //整型部分处理完毕
  }
  if (DecimalNum != "") {
    //小数部分
    decLen = DecimalNum.length;
    for (i = 0; i < decLen; i++) {
      n = DecimalNum.substr(i, 1);
      if (n != "0") {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (ChineseStr == "") {
    ChineseStr += cnNums[0] + cnIntLast;
  }
  return ChineseStr;
};

/**
 * Price
 * 精度 密码校验
 * @param {Number,String} pwd 需验证的密码
 * */
export const checkPwd = pwd => {
  var patrn = /^(\w){6,20}$/;
  if (!patrn.exec(pwd)) return false;
  return true;
};

/**
 * Business
 * 处理费率表的金额 分-元
 * @param {Array} originList [被转换的费率表]
 * */
export const handleRateRulesListToYuan = originList => {
  let resList = JSON.parse(JSON.stringify(originList));
  for (let item of resList) {
    // 将月下发额分转元
    // item.upperLimitAmount = item.upperLimitAmount === 0?9999999999:fenToYuan(item.upperLimitAmount);
    item.upperLimitAmount = checkNull(item.upperLimitAmount)
      ? ""
      : fenToYuan(item.upperLimitAmount); // fenToYuan, 分转元，小数点后两位,没有三位一逗号
    for (let obj of item.cooperatorRules) {
      // 将单人下发额分转元
      obj.monthLimitAmount = !checkNull(obj.monthLimitAmount)
        ? fenToWan(obj.monthLimitAmount)
        : 0;
      // 是否启用字段无值默认为true
      obj.restrictFlag = !checkNull(obj.restrictFlag) ? obj.restrictFlag : true;
    }
  }

  return resList;
};

/**
 * Price
 * 转换金额为万元单位
 * 分 - 万
 * @param  {Number|| String} num [分]
 * */
export const fenToWan = num => {
  // num = JSON.stringify(num).slice(0, JSON.stringify(num).length - 4) / 100
  let numTemp = num;
  if (numTemp.toString().indexOf("万") < 0) {
    num = Number(num) / 1000000;
    return num + "万";
  } else {
    return num;
  }
};

/**
 * Price
 * 强制保留2位小数，如：2，会在2后面补上00.即2.00
 * @param {Number,String} x 需要被转换的金钱
 * */
export const toDecimal2 = x => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = (x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }

  // let dotString = s.split('.')[1]
  // if(dotString.length > 2){
  //   console.log('如何')
  //   // console.log(dotString.substr(0,2))
  //   s = s.split('.')[0] + '.'+ dotString.substr(0,2)
  // }
  return s;
};

/**
 * Price
 * 格式化金钱，三位加一个逗号
 * @param {Number,String} num 需要被转换的金钱
 * */
export const priceToThousands = num => {
  if (num === 0) {
    return 0.0;
  }
  if (isNaN(Number(num))) {
    return num;
  }
  if (num) {
    // num = toDecimal2(num)
    let numTemp = num;

    if (numTemp.indexOf("-") > -1) {
      num = num.replace("-", "");
    }

    //将num中的$,去掉，将num变成一个纯粹的数据格式字符串
    num = num.toString().replace(/\$|\,/g, "");
    //如果num不是数字，则将num置0，并返回
    if ("" == num || isNaN(num)) {
      return "Not a Number ! ";
    }
    //如果num是负数，则获取她的符号
    var sign = num.indexOf("-") > 0 ? "-" : "";
    //如果存在小数点，则获取数字的小数部分
    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
    cents = cents.length > 1 ? cents : ""; //注意：这里如果是使用change方法不断的调用，小数是输入不了的
    //获取数字的整数数部分
    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
    //如果没有小数点，整数部分不能以0开头
    if ("" == cents) {
      if (num.length > 1 && "0" == num.substr(0, 1)) {
        return "Not a Number ! ";
      }
    }
    //如果有小数点，且整数的部分的长度大于1，则整数部分不能以0开头
    else {
      if (num.length > 1 && "0" == num.substr(0, 1)) {
        return "Not a Number ! ";
      }
    }
    //针对整数部分进行格式化处理，这是此方法的核心，也是稍难理解的一个地方，逆向的来思考或者采用简单的事例来实现就容易多了
    /*
      也可以这样想象，现在有一串数字字符串在你面前，如果让你给他家千分位的逗号的话，你是怎么来思考和操作的?
      字符串长度为0/1/2/3时都不用添加
      字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，然后继续往前数，直到不到往前数少于三位字符为止
     */
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        "," +
        num.substring(num.length - (4 * i + 3));
    }

    if (numTemp.indexOf("-") > -1) {
      return "-" + sign + num + cents;
    } else {
      return sign + num + cents;
    }
    //将数据（符号、整数部分、小数部分）整体组合返回
  }
};

/**
 * Price
 * 格式化费率  保留2位小数
 * @param {Number,String} rateNum 需要被转换的费率
 * */
export const rate = rateNum => {
  return rateNum.toFixed(2);
};

/**
 * Form
 * 判断输入是否为合法的手机号码 true为符合
 * @param {Number,String} phoneNum
 * */
export const checkPhoneNumber = phoneNum => {
  // var reg_mobile = /^1([358][0-9]|4[579]|66|7[01235678]|9[189])[0-9]{8}$/;
  // var reg_mobile = /^[1]([3-9])[0-9]{9}/;

  // let res = reg_mobile.test(phoneNum)

  // return res;

  var reg_mobile = /^[1]([3-9])[0-9]{9}$/;
  let res = reg_mobile.test(phoneNum);
  return res;

  // console.log(res)
  // if (!res) {
  //   return false
  // }

  // return true;
};

/**
 * Form
 * 是否最多两位小数
 * @parma {number}number
 * */
export const checkTwoPoint = number => {
  if (!checkNull(number)) {
    return false;
  }

  var partten = /^\d+(\.\d{1,2})?$/;
  return partten.test(number);
};

/**
 * Form
 * 判断，数字格式且小数点后保留两位小数
 * @param {Number,String} priceNum
 * */
export const checkPriceNumber = priceNum => {
  if (!checkNull(priceNum)) {
    var reg_price = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;
    let res = reg_price.test(priceNum);
    return res;
  }
};

/**
 * Form
 * 判空
 * @param {string} args
 * true为空，false为非空
 */
export const checkNull = args => {
  if (
    args === null ||
    args === "null" ||
    args === undefined ||
    args === "undefined" ||
    args === "" ||
    args.length === 0 ||
    args === false
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * Form
 * 判空 -- 校验对象里面每一项是否有空属性
 * @param {string} args
 * true为空，false为非空
 */
export const checkObjectNull = obj => {
  var flag = true;
  for (var prop in obj) {
    if (!obj[prop]) {
      flag = false;
      break;
    }
  }

  if (flag) {
    return true;
  } else {
    return false;
  }
};

/**
 * Form
 * 身份证验证 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 * @param {String} cardNo
 * true 为通过
 * */
export const checkIdCard = cardNo => {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  let res = reg.test(cardNo);
  if (!res) {
    return true;
    // messageTipsBox('身份证号信息不正确')
  } else {
    return false;
  }
};

/**
 * Form
 * 去掉空格
 * @param {String} str [待去空格的文本]
 * */
export const trim = str => {
  if (checkNull(str)) {
    return;
  }

  var result;
  result = str.replace(/(^\s+)|(\s+$)/g, "");
  result = result.replace(/\s/g, "");
  return result;
};

/**
 * Form
 * 去左右两边空格
 * @param {String} str [待去空格的文本]
 * */
export const sideTrim = str => {
  // console.log(str)
  if (
    str === null ||
    str === "null" ||
    str === undefined ||
    str === "undefined" ||
    str === "" ||
    str.length === 0
  ) {
    return "";
  } else {
    return str.replace(/^\s+|\s+$/g, "");
  }
};

/**
 * Form
 *  判空、非负浮点数
 *  @param {number, String} number
 * */
export const checkNumber = number => {
  if (checkNull(number)) {
    return false;
  }

  var partten = /^\d+(\.\d+)?$/;
  return partten.test(number);
};

/**
 * Date
 * 日期格式化为 - 连接到年份
 * @param {String} date
 * */
export const formatDate = date => {
  if (typeof date !== "object") return date;
  var Year = 0;
  var Month = 0;
  var Day = 0;
  var CurrentDate = "";
  //初始化时间
  Year = date.getFullYear();
  Month = date.getMonth() + 1;
  Day = date.getDate();
  CurrentDate += Year + "-";
  if (Month >= 10) {
    CurrentDate += Month + "-";
  } else {
    CurrentDate += "0" + Month + "-";
  }
  if (Day >= 10) {
    CurrentDate += Day;
  } else {
    CurrentDate += "0" + Day;
  }

  return CurrentDate;
};

/**
 * Date
 * 获取日期
 * time - 时间
 * */

export const getFormatDate = time => {
  var date = new Date();
  date.setTime(date.getTime() + time);

  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }

  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }

  var currentDate = year + seperator1 + month + seperator1 + strDate;
  return currentDate;
};

/**
 * Date
 * yyyy-mm-dd转中国时间
 * @param {String} date
 * */
export const formatChinaDate = date => {
  let dateArr = date.split("-");
  // console.log(dateArr)
  let d = new Date(dateArr[0], Number(dateArr[1]) - 1, dateArr[2]);
  // console.log(d);

  return d;
};

/**
 * Date
 * 获取当月第一天
 * */
export const getCurrentMonthFirst = () => {
  var date = new Date();
  date.setDate(1);
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return date.getFullYear() + "-" + month + "-" + day;
};

/**
 * Date
 * 获取年月，上个月的
 */

export const getOldYearMonth = () => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  var nowMonth = year + "-" + month;
  var arr = nowMonth.split("-");
  var year = arr[0]; //获取当前日期的年份
  var month = arr[1]; //获取当前日期的月份
  var year2 = year;
  var month2 = parseInt(month) - 1;
  if (month2 == 0) {
    //1月的上一月是前一年的12月
    year2 = parseInt(year2) - 1;
    month2 = 12;
  }
  if (month2 < 10) {
    //10月之前都需要补0
    month2 = "0" + month2;
  }
  var preMonth = year2 + "-" + month2;
  return preMonth;

  // var newDate = new Date(date)
  // var Year = 0;
  // var Month = 0;
  // var CurrentDate = '';
  // //初始化时间
  // Year = newDate.getFullYear();
  // Month = newDate.getMonth() ;
  // CurrentDate += Year + '-';
  // if (Month >= 10) {
  //   CurrentDate += Month;
  // }
  // else {
  //   CurrentDate += '0' + Month;
  // }

  // return CurrentDate;
};

/**
 * Date
 * 获取年月日,一整年
 */

export const getNextYear = date => {
  if (checkNull(date)) {
    return "";
  } else {
    var Year = date.getFullYear() + 1;
    var Month = date.getMonth() + 1;
    var day = date.getDate() - 1;

    if (Month < 10) {
      Month = "0" + Month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return Year + "-" + Month + "-" + day;
  }
};

/**
 * Date
 * 日期格式化为 - 连接到月份的
 * @param {String} date
 * */
export const formatDateMonth = date => {
  var newDate = new Date(date);
  var Year = 0;
  var Month = 0;
  var CurrentDate = "";
  //初始化时间
  Year = newDate.getFullYear();
  Month = newDate.getMonth() + 1;
  CurrentDate += Year + "-";
  if (Month >= 10) {
    // CurrentDate += Month + '-';
    CurrentDate += Month;
  } else {
    CurrentDate += "0" + Month;
  }

  return CurrentDate;
};

/**
 * Date
 * 获取当月最后一天
 * */
export const getCurrentMonthLast = () => {
  var date = new Date();
  var currentMonth = date.getMonth();
  var nextMonth = ++currentMonth;
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  var oneDay = 1000 * 60 * 60 * 24;
  var lastTime = new Date(nextMonthFirstDay - oneDay);
  var month = parseInt(lastTime.getMonth() + 1);
  var day = lastTime.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return date.getFullYear() + "-" + month + "-" + day;
};

/**
 * 格式化时间
 * @param {String} date [时间]
 * @param {String} type ['ymd:yyyy-mm-dd', 'ym:yyyy-mm']
 * */
export const dateFormat = (date, type) => {
  // 时间格式化 2019-09-08
  var typeTemp = type || "ymd";
  var newDate = new Date(date);
  var Year = newDate.getFullYear(),
    Month = newDate.getMonth() + 1,
    Day = newDate.getDate();
  var CurrentDate = "";

  if (Month < 10) {
    Month = "0" + Month;
  }

  if (Day < 10) {
    Day = "0" + Day;
  }

  if (typeTemp == "ymd") {
    CurrentDate += Year + "-" + Month + "-" + Day;
  } else {
    CurrentDate += Year + "-" + Month;
  }

  return CurrentDate;
};

/**
 * Date
 * 获取当前月 月初到月末的时间
 * */
export const getMonthStartEnd = () => {
  var now = new Date(); // 获取当前日期时间
  var monthStart = new Date(now.getFullYear(), now.getMonth(), 1); // 获取本月第一天的日期时间
  var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // 获取本月最后一天的日期时间（时间为23:59:59）
  return [formatDate(monthStart), formatDate(monthEnd)];
};

function filter(str) {
  // 特殊字符转义
  str += ""; // 隐式转换
  str = str.replace(/%/g, "%25");
  str = str.replace(/\+/g, "%2B");
  str = str.replace(/ /g, "%20");
  str = str.replace(/\//g, "%2F");
  str = str.replace(/\?/g, "%3F");
  str = str.replace(/&/g, "%26");
  str = str.replace(/\=/g, "%3D");
  str = str.replace(/#/g, "%23");
  return str;
}

/**
 * Date
 * 对象转url参数
 * {id:123,name:Hjx} ----> id=123&name=hjx
 * */
export const formateObjToParamStr = paramObj => {
  const sdata = [];
  for (let attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`);
  }
  return sdata.join("&");
};

/**
 * 参数判空，并提示不合法字段名
 * 例：
 * params = {
 *  name: 'DKing',
 *  id:'3',
 *  age:18
 * }
 * checkedParamsArr = [
 *  {name:'名字'},
 *  {id:'id'},
 *  {age:'年龄'}
 * ]
 * 返回值
 * true：所有必填项均以填
 * false：有必填项为空
 */
export const checkParamsIsNullTipValue = (params, checkedParamsArr) => {
  let list = [];
  for (let par of checkedParamsArr) {
    for (let k in par) {
      let obj = {
        key: k,
        value: par[k]
      };
      list.push(obj);
    }
  }

  for (let item in params) {
    if (checkNull(params[item])) {
      for (let obj of list) {
        if (item === obj["key"]) {
          // console.log('不能为空', obj['value']);
          alert(obj["value"] + "不能为空");
          return false;
        }
      }
    }
  }

  return true;
};

/**
 * 参数判空
 * @param {Object} params [待校验的参数]
 * @param {Array} noCheckedParamsArr [无需校验的参数]
 * */
export const checkParamsIsNull = (params, noCheckedParamsArr) => {
  var arr = [];
  for (let item in params) {
    let listItem = {
      key: item,
      value: params[item]
    };
    if (noCheckedParamsArr.indexOf(listItem.key) < 0) {
      arr.push(listItem);
    }
  }
  var resStrList = [];
  for (let obj of arr) {
    if (
      obj.value === null ||
      obj.value === "null" ||
      obj.value === undefined ||
      obj.value === "undefined" ||
      obj.value === "" ||
      obj.value.length === 0
    ) {
      // 开发时将参数的值打印出来，以便定位哪个参数为空
      // alert('必填参数不能为空')
      alert(obj.key, true);

      return false;
    } else {
      resStrList.push(true);
    }
  }

  if (resStrList.indexOf(false) < 0) {
    return true;
  }
};

/**
 * Array
 * 从数组中删除指定的对象
 * @param {Array<object>} list [列表]
 * @param {Any} child [待删除的对象]
 * */
export const arrayRemoveChild = (list, child) => {
  var newData = list.filter(function(item) {
    return item != child;
  });
  return newData;
};

// 验证邮箱格式
export const checkEmail = val => {
  // console.log(val)
  let isok;
  if (val != "") {
    var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    isok = reg.test(val);
    if (!isok) {
      return false;
    } else {
      return true;
    }
  }
};

/**
 * Array
 * 根据index索引删除数组对象
 * @param {Array<object>} list [列表]
 * @param {string || Number} index [待删除的下标]
 * */
export const arrayRemoveByIndex = (list, index) => {
  let indexTemp = Number(index);
  if (indexTemp <= list.length - 1) {
    for (var i = indexTemp; i < list.length; i++) {
      list[i] = list[i + 1];
      break;
    }
    list.length = list.length - 1;
  }
  return list;
};

// 存储localStorage
export const setLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

// 得到localStorage
export const getLocal = key => {
  return JSON.parse(localStorage.getItem(key));
};

// 得到localStorage - 未进行数据格式化

export const getLocalNoFormat = key => {
  return localStorage.getItem(key);
};

// 删除localStorage
export const delLocal = key => {
  localStorage.removeItem(key);
};

// 清空localStorage
export const clearLocal = () => {
  localStorage.clear();
};

// 存储sessionStorage
export const setSession = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

// 得到sessionStorage
export const getSession = key => {
  return JSON.parse(sessionStorage.getItem(key));
};

// 清空掉sessionStorage
export const clearSession = () => {
  sessionStorage.clear();
};

// 删除某个sessionStorage
export const delSession = key => {
  sessionStorage.removeItem(key);
};

/**
 * 根据批次状态编号转换状态txt
 * 批次状态 10-全部校验成功，20-部分校验失败，30-全部校验失败
 * @param {string || Number} BatchStateVal [状态码]

 * */
export const fitrBatchState = BatchStateVal => {
  switch (BatchStateVal) {
    case 9:
      return "校验中";
      break;
    case 10:
      return "全部校验成功";
      break;
    case 20:
      return "部分校验失败";
      break;
    default:
      return "全部校验失败";
  }
};

/**
 * 补发状态
 * */

export const bufaStateSbtn = BatchStateVal => {
  switch (BatchStateVal) {
    case 1:
      return "退款";
      break;
    case 10:
      return "待补发";
    case 11:
      return "已取消";
    case 20:
      return "待打款";
    case 30:
      return "处理中";
    case 40:
      return "全部打款完成";
    case 50:
      return "部分打款成功";
    case 60:
      return "全部打款失败";
      break;
  }
};
export const bufaStateSbtnIcon = BatchStateVal => {
  switch (BatchStateVal) {
    case 1:
      return "point-red";
      break;
    case 10:
      return "point-orange";
    case 11:
      return "point-gary";
    case 20:
      return "point-red";
    case 30:
      return "point-red";
    case 40:
      return "point-green";
    case 50:
      return "point-green";
    case 60:
      return "point-red";
      break;
  }
};
export const bufaState = BatchStateVal => {
  switch (BatchStateVal) {
    case 0:
      return "未补发";
      break;
    case 1:
      return "已补发";
      break;
  }
};
export const bufaBatchStateIcon = StateIconVal => {
  switch (StateIconVal) {
    case 1:
      return "point-green";
      break;
    case 0:
      return "point-red";
      break;
  }
};

/**
 * 根据开票状态编号转换状态icon
 * 批次状态 10-未开票，20-开票处理中，30-驳回，40-已开票
 * */
export const billingStatus = billingStatus => {
  switch (billingStatus) {
    case 20:
      return "开票处理中";
    case 30:
      return "开票成功";
    case 40:
      return "开票失败";
    case 60:
      return "开票失败";
    case 90:
      return "开票失败";
    case 95:
      return "已作废";
  }
};

export const billingStatusIcon = billingStatus => {
  switch (billingStatus) {
    case 20:
      return "point-orange";
    case 30:
      return "point-green";
    case 40:
      return "point-red";
    case 60:
      return "point-red";
    case 95:
      return "point-red";
    default:
      break;
  }
};

/**
 * 开票记录 - 开票详情
 * 发票状态: 2: 已作废，0: 作废中，1:正常发票
 * */
export const invoicingStatus = status => {
  switch (status) {
    case 3:
      return "部分作废";
    case 2:
      return "全部作废";
    case 0:
      return "作废中";
    case 1:
      return "正常发票";
    default:
      break;
  }
};

export const invoicingStatusIcon = status => {
  switch (status) {
    case 3:
      return "point-red";
    case 2:
      return "point-red";
    case 0:
      return "point-orange";
    case 1:
      return "point-green";
    default:
      break;
  }
};

/**
 * 开票记录 - 发票格式
 * 发票格式: 1: PDF格式，2: OFD格式，3:XML格式
 * */
export const invoiceFileFormat = status => {
  switch (status) {
    case 1:
      return "PDF格式";
    case 2:
      return "OFD格式";
    case 3:
      return "XML格式";
    case 4:
      return "OFD+XML格式";
    case 5:
      return "PDF+XML格式";
    default:
      break;
  }
};

/**
 * 根据批次状态编号转换状态icon
 * 批次状态 10-全部校验成功，20-部分校验失败，30-全部校验失败
 * @param {string || Number} StateIconVal [状态码]
 * */
export const fitrBatchStateIcon = StateIconVal => {
  switch (StateIconVal) {
    case 9:
      return "point-orange";
      break;
    case 10:
      return "point-green";
      break;
    case 20:
      return "point-red";
      break;
    default:
      return "point-red";
  }
};

/**
 * 根据证件编号转换文字
 * 证件信息
 * @param {string || Number} certificateVal [状态码]
 * */
export const certificateType = certificateVal => {
  switch (certificateVal) {
    case 1:
      return "身份证";
    case 2:
      return "港澳居民来往内地通行证";
    case 3:
      return "外国护照";
    // case 4:
    //   return "军官证";
    case 5:
      return "台湾居民来往大陆通行证";
    case 6:
      return "中华人民共和国港澳居民居住证";
    case 7:
      return "中华人民共和国台湾居民居住证";
    default:

      return null;
  }
};

/**
 * 根据收款渠道编号转换txt
 * 收款渠道 10-银行卡，20-支付宝，30-微信
 * @param {string || Number} ReceiptChannelVal [状态码]
 * */
export const fitrReceiptChannel = ReceiptChannelVal => {
  switch (ReceiptChannelVal) {
    case 10:
      return "银行卡";
    case 20:
      return "支付宝";
    case 51:
      return "中金支付电子账户";
    case 35:
      return "微信H5";
    case 30:
      return "微信";
    case 40:
      return "商户方微信";
    case 50:
      return "通联客户号";
    default:
    // return "微信"
  }
};

/**
 * 根据转换txt
 * 收款渠道 1-身份证，2-港澳居民来往内地通行证， 3-其他, 4-军官证, 5-'台湾居民来往大陆通行证
 * @param {string || Number} status [状态码]
 * */
export const idTypeStatus = status => {
  switch (status) {
    case 1:
      return "身份证";
      break;
    case 2:
      return "港澳居民来往内地通行证";
      break;
    case 3:
      return "其他";
      break;
    // case 4:
    //   return "军官证";
    //   break;
    case 5:
      return "台湾居民来往大陆通行证";
      break;
    default:
      break;
  }
}; //-----------------------------------------------------------------

/**
 * 根据付款状态码转换付款状态文字
 *下发状态 10-验证成功，20-验证失败，30-待支付，40-待打款，50-打款中，60-打款成功，70-打款失败
 *   @param {string || Number} OptionsVal [状态码]
 * */ export const paymentStatusOptions = OptionsVal => {
  switch (OptionsVal) {
    case 10:
      return "验证成功";
      break;
    case 20:
      return "验证失败";
      break;
    case 30:
      return "已取消";
      break;
    case 40:
      return "待打款";
      break;
    case 50:
      return "打款中";
      break;
    case 60:
      return "发放成功";
      break;
    case 70:
      return "发放失败";
      break;
  }
};

/**
 * 批次下发数据提交列表校验状态
 *下发状态 10-验证成功，20-验证失败，30-已取消，40-待打款，50-打款中，60-打款成功，70-打款失败，75-已退款
 *   @param {string || Number} distributeStatus [状态码]
 * */
export const filterDistributeStatus = distributeStatus => {
  switch (distributeStatus) {
    case 9:
      return "校验中";
    case 10:
      return "初验成功";
    case 20:
      return "验证失败";
    case 30:
      return "已取消";
    case 40:
      return "待打款";
    case 50:
      return "打款中";
    case 60:
      return "打款成功";
    case 70:
      return "打款失败";
    case 75:
      return "已退款";
    case 90:
      return "已退票";
    // case 65:
    //   return "已完成"
    //   break
  }
};
/**
 * 批次下发校验状态小图标
 * 提现模式下的 60--提现成功
 *   @param {string || Number} distributeStatus [状态码]
 * */
export const filterDistributeModeStatus = distributeStatus => {
  switch (distributeStatus) {
    case 9:
      return "校验中";
      break;
    case 10:
      return "初验成功";
      break;
    case 20:
      return "验证失败";
      break;
    case 30:
      return "已取消";
      break;
    case 40:
      return "待打款";
      break;
    case 46:
      return "待提现";
      break;
    case 50:
      return "打款中";
      break;
    case 60:
      return "提现成功";
      break;
    case 70:
      return "打款失败";
      break;
    case 75:
      return "已退款";
      break;
    case 90:
      return "已退票";
      break;
  }
};

/**
 * 批次下发校验状态小图标
 *下发状态 10-验证成功，20-验证失败，30-已取消，40-待打款，50-打款中，60-打款成功，70-打款失败
 *   @param {string || Number} distributeStatus [状态码]
 * */
export const filterDistributeStatusIcon = val => {
  switch (val) {
    case 9:
      return "point-orange";
      break;
    case 10:
      return "point-green";
      break;
    case 20:
      return "point-red";
      break;
    case 30:
      return "point-gary";
      break;
    case 40:
      return "point-orange";
      break;
    case 46:
      return "point-orange";
      break;
    case 50:
      return "point-orange";
      break;
    case 60:
      return "point-green";
      break;
    case 65:
      return "point-green";
      break;
    case 70:
      return "point-red";
      break;
    case 75:
      return "point-red";
      break;
    case 80:
      return "point-orange";
      break;
    case 90:
      return "point-red";
      break;
    default:
      return;
  }
};

// 批次明细交易信息查询订单状态
export const batchDetailOrderStatus = [
  {
    value: 10,
    label: "校验成功"
  },
  {
    value: 20,
    label: "校验失败"
  },
  {
    value: 30,
    label: "已取消"
  },
  {
    value: 40,
    label: "待打款"
  },
  {
    value: 50,
    label: "打款中"
  },
  {
    value: 60,
    label: "打款成功"
  },
  {
    value: 70,
    label: "打款失败"
  },
  {
    value: 75,
    label: "已退款"
  },
  {
    value: 90,
    label: "已退票"
  }
  // 10-验证成功，20-验证失败，30-已取消,40-待打款，50-打款中，60-打款成功，70-打款失败,80-退票中,90-已退票
];

// 提现模式批次明细交易信息查询订单状态
export const batchDetailOrderStatusMode = [
  {
    value: 10,
    label: "校验成功"
  },
  {
    value: 20,
    label: "校验失败"
  },
  {
    value: 30,
    label: "已取消"
  },
  {
    value: 40,
    label: "待打款"
  },
  {
    value: 46,
    label: "待提现"
  },
  {
    value: 60,
    label: "提现成功"
  },
  {
    value: 75,
    label: "已退款"
  },
  {
    value: 90,
    label: "已退票"
  }
  // 10-验证成功，20-验证失败，30-已取消,40-待打款，50-打款中，60-打款成功，70-打款失败,80-退票中,90-已退票
];

/**
 * 充值记录处理状态处理
 *处理状态   20--充值成功  30--挂账(待操作)  40--充值失败
 *   @param {string || Number} RechargeStatus [状态码]
 * */
export const filterRechargeStatus = RechargeStatus => {
  switch (RechargeStatus) {
    case -10:
      return {
        text: "加款失败",
        className: "point-red"
      };
    case 11:
      return {
        text: "未分配",
        className: "point-orange"
      };
    case 20:
      return {
        text: "加款成功",
        className: "point-green"
      };
    case 30:
      return {
        text: "挂账",
        className: "point-orange"
      };
    case 40:
      return {
        text: "已撤销",
        className: "point-gary"
      };
    case 52:
      return {
        text: "退款待确认",
        className: "point-orange"
      };
    case 53:
      return {
        text: "退款处理中",
        className: "point-orange"
      };
    case 60:
      return {
        text: "退款成功",
        className: "point-green"
      };
    case 61:
      return {
        text: "退款失败",
        className: "point-red"
      };
  }
};

/**
 * 批次数据准备付款状态
 *处理状态   订单状态 -2-中断（预留），-1-退款（预留），10-待付款，11-已取消,20-待打款，30-打款中，40-已完成,全部-不传此参数
 *   @param {string || Number} batchStatus [状态码]
 * */
export const filterbatchStatus = batchStatus => {
  switch (batchStatus) {
    case 10:
      return "待支付";
    case 11:
      return "已取消";
    case 20:
      return "待打款";
    case 30:
      return "处理中";
    case 40:
      return "全部打款成功";
    case 50:
      return "部分打款成功";
    case 60:
      return "全部打款失败";
  }
};

//付款状态判断
export const filterbatchStatusIcon = val => {
  switch (val) {
    case 10:
      return "point-orange";
    case 11:
      return "point-gary";
    case 20:
      return "point-orange";
    case 30:
      return "point-orange";
    case 40:
      return "point-green";
    case 50:
      return "point-orange";
    case 60:
      return "point-red";
    default:
      return;
  }
};

/**
 * 验证状态
 * */
export const validatingStatus = batchStatus => {
  switch (batchStatus) {
    case 10:
      return "待验证";
    case 30:
      return "驳回";
    case 20:
      return "验证成功";
  }
};
export const validatingStatusIcon = val => {
  switch (val) {
    case 10:
      return "point-orange";
    case 20:
      return "point-green";
    case 30:
      return "point-red";
    default:
      return;
  }
};

/**
 * 制单状态
 * */
export const affirmStateStatusIcon = val => {
  switch (val) {
    case 9:
      return "point-gary";
    case 10:
      return "point-orange";
    case 20:
      return "point-orange";
    case 30:
      return "point-orange";
    case 40:
      return "point-green";
    case 50:
      return "point-red";
    default:
      return;
  }
};

/**
 * 制单描述
 * */
export const affirmStateStatusDesc = val => {
  switch (val) {
    case 9:
      return "无需制单";
    case 10:
      return "待制单";
    case 20:
      return "提交制单";
    case 30:
      return "制单中";
    case 40:
      return "已制单";
    case 50:
      return "制单失败";
    default:
      return;
  }
};

export const orderStateStatusDesc = val => {
  switch (val) {
    case 10:
      return "待确认";
    case 11:
      return "已取消";
    case 20:
      return "待打款";
    case 30:
      return "处理中";
    case 40:
      return "全部打款成功";
    case 50:
      return "部分打款成功";
    case 60:
      return "全部打款失败";
    default:
      return;
  }
};

// 手机号隐藏中间四位
export const getTelNo = tel => {
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, "$1****$2");
};

// 批次数据准备-批次状态列表
export const batchStateList = [
  { value: "10", label: "全部校验成功", className: "point-green" },
  { value: "20", label: "部分校验失败", className: "point-red" },
  { value: "30", label: "全部校验失败", className: "point-red" },
  { value: "9", label: "校验中", className: "point-orange" }
];

// 批次数据准备-付款状态列表
export const payStatusOptions = [
  { value: "10", label: "待付款", className: "point-orange" },
  { value: "11", label: "已取消", className: "point-gary" },
  { value: "20", label: "待打款", className: "point-orange" },
  { value: "30", label: "处理中", className: "point-orange" },
  { value: "40", label: "全部打款成功", className: "point-green" },
  { value: "50", label: "部分打款成功", className: "point-green" },
  { value: "60", label: "全部打款失败", className: "point-red" }
];
//批次数据准备-收款渠道
export const receiptChannel = [
  { value: "10", label: "银行卡" },
  { value: "20", label: "支付宝" },
  { value: "40", label: "商户方微信" }
];
/**
 *纳税人类型
 * */
export const taxpayerTypeStatus = val => {
  switch (val) {
    case 10:
      return "一般纳税人";
    case 20:
      return "小规模纳税人";
    default:
      return;
  }
};

/**
 * 开票类型
 * */
export const invoiceTypeStatus = val => {
  switch (val) {
    case 10:
      return "普通发票";
    case 20:
      return "增值税专用发票";
    default:
      return;
  }
};

// 补全图片路径
export const changeImgUrl = newUrl => {
  if (!newUrl) {
    return "";
  }
  let isChange = newUrl.indexOf("http");
  let urlPrefix = "https://hvyogo-open.oss-cn-beijing.aliyuncs.com/";
  if (isChange > -1) {
    return newUrl;
  } else if (isChange < 0) {
    return urlPrefix + newUrl;
  }
};

// 判空
export const isNull = args => {
  if (
    args === null ||
    args === "null" ||
    args === undefined ||
    args === "undefined" ||
    args === "" ||
    args.length === 0
  ) {
    return true;
  } else {
    false;
  }
};

/**
 * 表单验证开启开关
 * 开启之后，表单验证不通过则不发起接口请求
 * 关闭之后，表单验证不通过则发起接口请求
 * @param {Boolean} valid [页面表单验证是否通过]
 * */
export const validSwitch = valid => {
  return valid;
  // return true;
};

/* *
 * Date
 * 获取当月第一天和当天时间，
 * 此工程所有时间选框默认开始为当月第一天，结束时间为当月的当天
 * */
export const getFirstAndCurrentDay = () => {
  var now = new Date();
  var strLink = "-";
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var day = now.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (day >= 1 && day <= 9) {
    day = "0" + day;
  }
  var firstDate = year + strLink + month + strLink + "01";
  var sysDate = year + strLink + month + strLink + day;

  return [firstDate, sysDate]; //以数组形式返回  ;
};

/* *
 * Date
 * 获取当前的时间 包括时，分，秒
 * */
export const getNowFormatDateHMS = () => {
  let date = new Date();
  let seperator1 = "-"; //年月日之间的分隔
  let seperator2 = ":"; //时分秒之间的分隔
  let month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1; //获取月,如果小于10,前面补个0
  let strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取日,如果小于10,前面补个0
  let strHours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //获取小时,如果小于10,前面补个0
  let strMinutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //获取分,如果小于10,前面补个0
  let strSeconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //获取秒,如果小于10,前面补个0
  let currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    strHours +
    seperator2 +
    strMinutes +
    seperator2 +
    strSeconds; //拼接一下
  return currentdate; //返回
};

/**
 * Date
 * 获取当前的日期
 * */
export const getNowFormatDate = () => {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentDate = year + seperator1 + month + seperator1 + strDate;
  return currentDate;
};

/**
 * Date
 * 获取年月
 */
export const getYearMonth = date => {
  if (checkNull(date)) {
    return "";
  } else {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var monthType = year + seperator1 + month;
    return monthType;
  }
};

/**
 * Date
 * 转换年月格式
 */
export const getYearMonthType = date => {
  if (checkNull(date)) {
    return "";
  } else {
    let dateType = formatDate(date);
    let monthType = dateType.substring(0, dateType.length - 3);
    return monthType;
  }
};

// 校验状态
export const verifyStatus = [
  {
    value: 10,
    label: "校验成功"
  },
  {
    value: 20,
    label: "校验失败"
  }
];

// 身份证
export const idCardInfo = [
  {
    label: "身份证",
    value: 1
  }
];

/**
 * 批次数据准备操作按钮展示处理 - 判断支付还是查看
 * val - 订单状态码 - payStatusOptions枚举类
 * */
export const jurisdictionfalg = val => {
  switch (val) {
    case 40:
      return true;
      break;
    case 20:
      return true;
      break;
    case 30:
      return true;
      break;
    case 40:
      return true;
      break;
    case 50:
      return true;
      break;
    case 60:
      return true;
      break;
    default:
      return false;
  }
};
/**
 *@desc   验证能否被查看
 *@param  [string | Number ] val 订单状态码
 */
export const jurisdiction = val => {
  switch (val) {
    case 20:
      return true;
      break;
    case 30:
      return true;
      break;
    case 40:
      return true;
      break;
    case 50:
      return true;
      break;
    case 60:
      return true;
    default:
      return false;
  }
};

/**
 *@desc   判断能否支付
 *@param  [string | Number ] val 订单状态码
 */
export const jurisdictionPayment = val => {
  switch (val) {
    case 10:
      return true;
      break;
    default:
      return false;
  }
};

/**
 * File
 * 上传文件类型校验 >-1 为符合条件返回true 反之则不符合条件 返回false
 * @param {File} file 待检验的文件
 * @param {Array} typeList 要求的文件类型集合
 * */
export const checkFileType = (file, typeList) => {
  let splitList = file.name.split(".");
  let l = splitList.length - 1;
  let currentType = splitList[l];

  return typeList.indexOf(currentType) > -1;
};

/**
 * 弹窗--提示
 * @param {messageTips} messageTips [提示信息]
 * */
export const messageTipsBox = messageTips => {
  MessageBox(messageTips, "提示", {
    confirmButtonText: "确定",
    confirmButtonClass: "btnFullColor"
  });
};

/**
 * File
 * 上传文件内存大小校验 符合条件返回true 反之则不符合条件 返回false
 * @param {File} file 待检验的文件
 * @param {Number} size 要求的文件大小
 * */
export const checkFileSize = (file, size) => {
  let fileSize = file.size / 1024 / 1024;
  return Number(fileSize) < Number(size);
};

/**
 * File
 * 上传图片添加宽高限制
 * */
export const astrictStyle = (widthSmall, widthMax, heightNum, file) => {
  const isJPG = file.type === "image/png";
  if (!isJPG) {
    MessageBox("上传头像图片只能是png格式", "提示", {
      confirmButtonText: "确定",
      showCancelButton: false,
      confirmButtonClass: "btnFullColor"
    });
  }
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onload = function(event) {
      var image = new Image();
      image.onload = function() {
        // console.log('上传图片限制', widthMax)
        var width = this.width;
        var height = this.height;
        if (width < widthSmall || width > widthMax) {
          MessageBox(
            "图片宽度必须在" + widthSmall + "～" + widthMax + "px之间！",
            "提示",
            {
              confirmButtonText: "确定",
              showCancelButton: false,
              confirmButtonClass: "btnFullColor"
            }
          );
          reject();
          return false;
        }
        if (height > heightNum || height < heightNum) {
          MessageBox("图片高度需为" + heightNum + " px！", "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            confirmButtonClass: "btnFullColor"
          });
          reject();
          return false;
        }
        resolve();
      };
      image.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
  return isJPG;
};

/**
 * Form
 * 判空，除了空数组不做判断
 * @param {string} args
 * true为空，false为非空
 */
export const checkNullNoArr = args => {
  if (
    args === null ||
    args === "null" ||
    args === undefined ||
    args === "undefined" ||
    args === "" ||
    args === false
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * 自由职业者管理 - 实名状态
 * @param {val} args
 */
export const verifiedStatus = val => {
  switch (val) {
    case 1:
      return "认证成功";
    case 0:
      return "未认证";
    case -1:
      return "验证失败";
    case -2:
      return "手机号重复";
    default:
      return;
  }
};

/**
 * 部门级别
 * @param {string || Number} departmentLevel [状态码]
 * */
export const fitrDepartmentLevel = departmentLevel => {
  switch (departmentLevel) {
    case 1:
      return "一级";
    case 2:
      return "二级";
    case 3:
      return "三级";
    case 4:
      return "四级";
    case 5:
      return "五级";
    default:
    // return "微信"
  }
};

/**
 * 自由职业者列表 - 导出协议记录
 * @param {string || Number} status [状态码]
 * */
export const exportStatusDesc = status => {
  switch (status) {
    case 0:
      return "导出中";
    case 1:
      return "导出完成";
    case 2:
      return "导出失败";
    default:
      break;
  }
};

/**
 * 自由职业者列表 - 导出类型
 * @param {string || Number} status [状态码]
 * */
export const exportTypeDesc = status => {
  switch (status) {
    case 1:
      return "数据导出";
    case 0:
      return "协议导出";
    case 101:
      return "电子回单";
    case 21:
      return "批量下载报名二维码";
    case 22:
      return "资质导出";
    default:
      break;
  }
};

/**
 * 充值记录 - 可开票详情
 * @param {string || Number} status [状态码]
 * */
export const invoicedDetailDesc = status => {
  switch (status) {
    case 3:
      return "已销预开金额：";
    case 4:
      return "销预开中金额：";
    case 1:
      return "已开票金额：";
    case 2:
      return "开票中金额：";
    default:
      break;
  }
};

/**
 * 获取日期
 * @param {string || Number} d [日期]
 * @param {string || Number} num [转换的天数]
 */
export const getDay = (d, num) => {
  const date = new Date(new Date(d).setDate(new Date(d).getDate() + num));
  const year = date.getFullYear();
  const month = (date.getMonth() + 1 + "").padStart(2, "0");
  const day = (date.getDate() + "").padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * 是否是闰年
 * @param {string} year [日期]
 */
export const isLeap = year => {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
};

/**
 * 返回去年日期
 * @param {string} d [去年的日期]
 */
export const lastYearDat = d => {
  const date = new Date(d);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const lastYear = year - 1;
  const thisYearIsLeap = isLeap(year);
  const lastYearIsLeap = isLeap(lastYear);
  // 特殊情况：去年是否是闰年 或 今年是闰年且为12月31日
  if (lastYearIsLeap || (thisYearIsLeap && month == 12 && day == 31))
    return getDay(d, -366);
  return getDay(d, -365);
};

/**
 *  判断是否是一个空函数体
 *  @param {Function} func
 * */
export const isEmptyFun = func => {
  if (typeof func != "function") {
    return false;
  }

  let str = func.toString().replace(/\s+/g, "");
  str = str.match(/{.*}/g)[0];
  return str === "{}";
};

/**
 * 登录 - 网易易盾错误信息
 * https://support.dun.163.com/documents/15588062143475712?docId=294963751458885632
 * @param {param} props
 */
export const getNetEaseYiDunStatus = props => {
  return {
    501: "请求失败，请检查一下您的网络",
    502: "请求脚本资源失败",
    432: "非法业务ID，请检查服务是否到期",
    1000: "未知错误",
    300: "校验未通过，轨迹错误",
    200: "校验未通过，业务错误，检查次数是否超限"
  }[props];
};

/**
 * Form
 *  判空、正整数
 *  @param {number, String} number
 * */
export const checkInteger = number => {
  if (checkNull(number)) {
    return false;
  }

  var reg = /^[0-9]*$/;
  return reg.test(number);
};

/**
 * 中文字符转为英文
 * @param chineseChar: 需要转换的字符
 */
export const chineseChar2englishChar = chineseChar => {
  // 将单引号‘’都转换成'，将双引号“”都转换成"
  let str = chineseChar.replace(/[’|‘]/g, "'").replace(/[“|”]/g, '"');
  // 将中括号【】转换成[]，将大括号｛｝转换成{}
  str = str
    .replace(/【/g, "[")
    .replace(/】/g, "]")
    .replace(/｛/g, "{")
    .replace(/｝/g, "}");
  // 将逗号，转换成,，将：转换成:
  str = str.replace(/，/g, ",").replace(/：/g, ":");
  //将《转换为<，将》转换为>
  str = str.replace(/《/g, "<").replace(/》/g, ">");
  //将句号。转换成.，将问号？转换为?
  str = str.replace(/。/g, ".").replace(/？/g, "?");
  //将！转换为!
  str = str.replace(/！/g, "!");
  //将￥转换为$
  str = str.replace(/￥/g, "$");

  return str;
};

/**
 * 发放状态
 * @param {param} props
 */
export const getIssueStatusDesc = props => {
  return {
    0: "待发放",
    1: "已发放",
    "-1": "已取消"
  }[props];
};

/**
 * 服务费明细-提现 - 上传状态
 * @param {param} props
 */
export const getUploadStatusDesc = props => {
  return {
    0: "待上传",
    1: "上传成功"
  }[props];
};

/**
 * Form
 * 手机号隐藏中间四位脱敏
 * @param {String} str [手机号]
 * */
export const getSecretTelNo = tel => {
  if (tel) {
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    return tel.replace(reg, "$1****$2");
  }
};

/**
 * Form
 * 字符串小数点往前移动两位，小数点位数不够两位就补0  100->1.00  10->0.10  1->0.01  9999.9999->99.999999
 * @param {String} str
 * */
export const formatPrice = str => {
  if (str.indexOf(".") == -1) {
    // 没有小数点
    return fenToYuan(str);
  } else {
    // 有小数点
    const arr = str.split(".");
    let value = "";
    if (arr[0].length >= 3) {
      value = `${arr[0].slice(0, arr[0].length - 2)}.${arr[0].slice(
        arr[0].length - 2
      )}`;
    } else if (arr[0].length == 2) {
      value = `0.${arr[0]}`;
    } else {
      value = `0.0${arr[0]}`;
    }
    return `${value}${arr[1].replace(/0*$/, "")}`;
  }
};

/**
 * 优惠券中心 - 优惠券管理 - 优惠券状态枚举
 * @param {param} props
 */
export const getCouponStatus = props => {
  return {
    1: { title: "进行中", className: "point-orange" },
    2: { title: "已截止", className: "point-red" },
    3: { title: "已使用", className: "point-green" }
  }[props];
};

/**
 * 佣金结算周期
 * @param {param} status
 */
export const getCommissionSettlementCycleDesc = status => {
  return {
    MONTH: "月结",
    WEEK: "周结",
    DAY: "日结"
  }[status];
};

/**
 * Date
 * 日期年周 - 换算成时间段
 * @param {String} date
 * */

export const parseISOWeek = isoWeekString => {
  const isoWeekDate = isoWeekString;
  const [year, week] = isoWeekDate.split("-W");
  const firstDay = new Date(year, 0, 1); // 1月1日;
  const dayOfWeek = firstDay.getDay(); // 获取星期几，0（周日）到6（周六）
  const diff = firstDay.getDate() - dayOfWeek; // 计算第一天应该是星期几
  const firstWeekday = new Date(firstDay.setDate(diff + 1)); //设置为周一
  const daysToAdd = (week - 1) * 7; // 计算从第一周开始的天数差
  const startOfWeek = new Date(
    firstWeekday.setDate(firstWeekday.getDate() + daysToAdd)
  );
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(endOfWeek.getDate() + 6); // 周的最后一天是开始日期的第7天
  return formatDate(startOfWeek) + "至" + formatDate(endOfWeek);
};

/**
 * Date
 * 日期年周 - 换算成年月
 * @param {String} date
 * */
export const parseISOWeekChangeMonth = isoWeekString => {
  const [year, week] = isoWeekString.split("-W").map(Number);
  const simple = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));
  const day = simple.getUTCDay() || 7; // JavaScript的getDay()返回0-6，这里调整为1-7
  simple.setUTCDate(simple.getUTCDate() + (day < 4 ? 4 - day : 11 - day)); // 找到周一
  const startOfWeek = new Date(simple); // 周一
  const endOfWeek = new Date(simple); // 周日
  endOfWeek.setUTCDate(endOfWeek.getUTCDate() + 6); // 加6天到周一得到周日
  return startOfWeek.toISOString().slice(0, 10);
};

/**
 * Date
 * 获取3个月时间
 */
export const getThreeMonthDate = () => {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
  return [start, end];
};

/**
 * 字符串指定位置添加一个字符
 * @param {String} str [原始字符串]
 * @param {String} char [添加字符串]
 * @param {number} index [位置]
 */
export const insertCharAt = (str, char, index) => {
  var strArray = str.split("");
  strArray.splice(index, 0, char);
  return strArray.join("");
};

/**
 * 字符串拼接
 * */
export const getStrJoin = str => {
  if (checkNull(str)) return "";

  if (str.length > 4) {
    return `${str.slice(0, 4)}-${str.slice(4)}`;
  }
  return str;
};

/**
 * Date
 * 日期格式化为 - 连接到周份的
 * @param {String} date
 * */
export const formatDateWeek = date => {
  date = new Date(date);
  var Year = date.getFullYear();
  var date2 = new Date(date.getFullYear(), 0, 1);
  var day1 = date.getDay();
  if (day1 == 0) day1 = 7;
  var day2 = date2.getDay();
  if (day2 == 0) day2 = 7;
  var weekDate = Math.round(
    (date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) /
      86400000
  );
  var weekTime = Math.ceil(weekDate / 7) + 1;
  if (weekTime === 53) {
    return Year + 1 + "-W01";
  } else {
    return Year + "-W" + weekTime.toString().padStart(2, "0");
  }
};

/**
 *  任务列表- 报名详情 证件要求
 * @param {string || Number} status [状态码]
 * */
export const requirementQualificationDesc = status => {
  switch (status) {
    case 10:
      return "健康证";
    case 30:
      return "驾驶证";
    default:
      break;
  }
};

/**
 *  验证状态
 * @param {string || Number} status [状态码]
 * */
export const verifyStatusDesc = status => {
  return {
    9: {
      className: "point-orange",
      label: "待验证"
    },
    10: {
      className: "point-green",
      label: "验证成功"
    },
    20: {
      className: "point-red",
      label: "验证失败"
    }
  }[status];
};

/**
 *  公网图片回显地址
 *  @param {String} url
 * */
export const publicNetUrl = url => {
  var httpUrl = "http://hvyogo-open.oss-cn-beijing.aliyuncs.com/";

  if (checkNull(url)) {
    return false;
  }

  return `${httpUrl}${url}`;
};



// WEBPACK FOOTER //
// ./src/filters/filters.js